export default __webpack_public_path__ + "static/media/toRight.642a74da.svg";